// Absolute origin for backend API calls. In dev this is empty so Vite's
// `/api/*` proxy handles routing; in production it's set to
// https://api.getpowermove.com at build time via render.yaml's
// VITE_API_BASE_URL env var.
export const API_ORIGIN: string = import.meta.env.VITE_API_BASE_URL ?? '';
